import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

const CustomDropdownAdmin = ({ 
  StateList, 
  DistrictList, 
  SchoolList, 
  ThemeList, 
  SubThemeList, 
  handleSelectState, 
  handleSelectDistrict, 
  handleSelectSchool, 
  handleSelectTheme, 
  handleSelectSubTheme, 
  mode = 'state' 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(mode === 'state' ? "All States/UTs/ABs" : 
                                                  mode === 'district' ? "All Districts" : 
                                                  mode === 'school' ? "All Schools" : 
                                                  mode === 'theme' ? "All Themes" : 
                                                  "All Sub-Themes");

  const [hoveredItem, setHoveredItem] = useState(null); // Track hovered item

  const handleSelect = (id, name) => {
    if (mode === 'state') {
      handleSelectState(id);  // Passing the selected state ID to the parent
    } else if (mode === 'district') {
      handleSelectDistrict(id);  // Passing the selected district ID to the parent
    } else if (mode === 'school') {
      handleSelectSchool(id);  // Passing the selected school ID to the parent
    } else if (mode === 'theme') {
      handleSelectTheme(id);  // Passing the selected theme ID to the parent
    } else if (mode === 'subtheme') {
      handleSelectSubTheme(id);  // Passing the selected subtheme ID to the parent
    }
    setSelectedItem(name);
    setIsOpen(false); // Close the dropdown after selection
  };

  const renderList = mode === 'state' ? StateList :
                    mode === 'district' ? DistrictList :
                    mode === 'school' ? SchoolList :
                    mode === 'theme' ? ThemeList :
                    SubThemeList;

  const renderName = mode === 'state' ? 'state_name' : 
                    mode === 'district' ? 'district_name' :
                    mode === 'school' ? 'school_name' :
                    mode === 'theme' ? 'theme_name' :
                    'subtheme_name';

  const renderId = mode === 'state' ? 'state_id' : 
                   mode === 'district' ? 'district_id' :
                   mode === 'school' ? 'school_id' :
                   mode === 'theme' ? 'theme_id' :
                   'subtheme_id';

  const allItem = mode === 'state' ? "All States/UTs/ABs" : 
                  mode === 'district' ? "All Districts" : 
                  mode === 'school' ? "All Schools" : 
                  mode === 'theme' ? "All Themes" : 
                  "All Sub-Themes";

  return (
    <div className="dropdown" style={{ position: 'relative' }}>
      <div
        className="dropdown__selected1"
        style={{
          padding: '10px',
          cursor: 'pointer',
          whiteSpace: "nowrap",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          color: '#66615b',
          fontSize: '14px',
        }}
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedItem} <span>{isOpen ? <FiChevronUp /> : <FiChevronDown />}</span>
      </div>

      {isOpen && (
        <ul
          className="dropdown__list1"
          style={{
            position: 'absolute',
            top: '100%',
            left: '0',
            right: '0',
            maxHeight: '150px',
            overflowY: 'auto',
            border: '1px solid #ccc',
            backgroundColor: '#fff',
            listStyle: 'none',
            padding: '0',
            margin: '0',
            zIndex: '1000',
            borderRadius: '0',
          }}
        >
          <li
            key={`all-${mode}`}
            onClick={() => handleSelect("", allItem)}
            style={{
              padding: '10px',
              cursor: 'pointer',
              borderBottom: '1px solid #eee',
              borderRadius: '0',
              color: '#66615b',
              fontSize: '14px',
              backgroundColor: hoveredItem === 'all' ? 'rgb(62, 105, 231)' : 'transparent',
              color: hoveredItem === 'all' ? 'white' : '#66615b',
            }}
            onMouseEnter={() => setHoveredItem('all')}
            onMouseLeave={() => setHoveredItem(null)}
          >
            {allItem}
          </li>
          {renderList.map((item, index) => (
            <li
              key={index}
              onClick={() => handleSelect(item[renderId], item[renderName])}
              style={{
                padding: '10px',
                cursor: 'pointer',
                borderBottom: '1px solid #eee',
                borderRadius: '0',
                color: '#66615b',
                fontSize: '14px',
                backgroundColor: hoveredItem === index ? 'rgb(62, 105, 231)' : 'transparent',
                color: hoveredItem === index ? 'white' : '#66615b',
              }}
              onMouseEnter={() => setHoveredItem(index)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              {item[renderName]}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdownAdmin;
